export default __webpack_public_path__ + "static/media/Icon_Business_16px.a52befba.svg";